enum CustomerStatus {
  'Active',
  'Inactive'
}

export default CustomerStatus;
